import { render, staticRenderFns } from "./RecipeCreate.vue?vue&type=template&id=0577d34c&"
import script from "./RecipeCreate.vue?vue&type=script&lang=js&"
export * from "./RecipeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports